import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import { importValidationColumnDefinition } from '../../shared/columnDefinitions';
import { categoryPropTypes } from '../../shared/propTypes';

import getColumnDefinitions from './columnDefinitions';
import { getPillDefinitions, Resources } from './constants';
import { ConfigurationSettingsPropTypes } from './propTypes';

class DataGrid extends PureComponent {
  static propTypes = {
    activePill: PropTypes.string.isRequired,
    data: ConfigurationSettingsPropTypes.isRequired,
    isLoading: PropTypes.bool.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    fetchConfigurationSettingsPill: PropTypes.func.isRequired,
    changePeriod: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(categoryPropTypes),
    countryTaxTypes: PropTypes.arrayOf(PropTypes.shape({
      countryTaxType: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })),
  };

  componentDidMount() {
    const {
      activePill,
      period,
      fetchConfigurationSettingsPill,
    } = this.props;

    fetchConfigurationSettingsPill(activePill, period.name);
  }

  componentDidUpdate(prevProps) {
    const { activePill: prevPill, period: prevPeriod } = prevProps;
    const {
      activePill,
      period,
      fetchConfigurationSettingsPill,
      changePeriod,
    } = this.props;

    if (activePill !== prevPill) {
      fetchConfigurationSettingsPill(activePill, period.name);
    }

    if (period.name !== prevPeriod.name) {
      changePeriod(activePill, period);
    }
  }

  onRowDataUpdated = params => {
    if (params.gridApi) {
      params.gridApi.applyColumnState({
        state: [
          { colId: importValidationColumnDefinition.field, sort: 'asc' },
        ],
      });
    }
  };

  render() {
    const {
      activePill,
      data,
      isLoading,
      countryTaxTypes,
      categories,
    } = this.props;

    const columnDefs = getColumnDefinitions({ countryTaxTypes, categories })[activePill];
    const rowData = data[Resources[activePill]];

    const hasImportValidationsErrors = rowData && rowData.some(entity => entity.importStatusDetail === -1);

    const modifiedColumnDefs = hasImportValidationsErrors
      ? [{ ...importValidationColumnDefinition, field: 'importValidation' }, ...columnDefs]
      : columnDefs;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <AgGrid
          columnDefs={modifiedColumnDefs}
          rowData={rowData}
          headerHeight={60}
          isGridLoading={isLoading}
          withSearchBar
          onRowDataUpdated={this.onRowDataUpdated}
        />
      </div>
    );
  }
}

export default withPillNavigation(getPillDefinitions)(DataGrid);
